module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_28.abd3e1ed.png";